import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { PermissionService } from '../services/permission.service';

export const permissionGuard: CanActivateFn = (route, state) => {
    const router = inject(Router);
    const permissionService = inject(PermissionService);
    const authService = inject(AuthService);

    const { permissions, portal } = route.data;

    // Se as permissões já foram carregadas, faz verificação direta
    if (permissionService.isLoaded) {
        return checkPermissions(permissionService, router, route.data, state);
    }

    // Se não foram carregadas, aguarda o carregamento
    return authService.getDadosLogin().pipe(
        map(() => {
            return checkPermissions(
                permissionService,
                router,
                route.data,
                state
            );
        }),
        catchError(() => {
            // Em caso de erro no carregamento, redireciona para login
            router.navigate(['/auth/login']);
            return of(false);
        })
    );
};

function checkPermissions(
    permissionService: PermissionService,
    router: Router,
    routeData: any,
    state: any
): boolean {
    const { permissions, portal } = routeData;

    // Verifica acesso ao portal específico
    if (portal && !permissionService.hasPortalAccess(portal)) {
        router.navigate(['/pages/access-denied'], {
            queryParams: {
                path: state.url,
                portal: portal,
            },
        });
        return false;
    }

    // Verifica permissões específicas
    if (permissions && !permissionService.hasAnyPermission(permissions)) {
        router.navigate(['/pages/access-denied'], {
            queryParams: {
                path: state.url,
                permissions: permissions.join(','),
            },
        });
        return false;
    }

    return true;
}
